import Vue from "vue";
import Router from "vue-router";

import Login from "./views/Login.vue";

import Assinaturas from "./views/Assinaturas.vue";
import Assine from "./views/Assine.vue";
import Plano from "./views/Plano.vue";
import Ativar from "./views/Ativar.vue";
import Usuario from "./views/Usuario.vue";
import AlterarSenha from "./views/AlterarSenha.vue";
import NewFlip from "./views/NewFlip.vue";

Vue.use(Router);

const router = new Router({
  base: process.env.VUE_APP_BASE_PATH,
  mode: "history",
  routes: [
    {
      path: "/",
      component: Assine,
      meta: {
        publico: true
      }
    },
    {
      path: "/assine",
      component: Assine,
      meta: {
        publico: true
      }
    },
    {
      path: "/assinaturas",
      component: Assinaturas
    },
    {
      path: "/plano/:url",
      component: Plano
    },
    {
      path: "/ativar/:id",
      component: Ativar
    },
    {
      path: "/meus-dados",
      component: Usuario
    },
    {
      path: "/alterar-senha",
      component: AlterarSenha
    },
    {
      path: "/newflip",
      component: NewFlip,
      meta: {
        publico: true
      }
    },
    {
      path: "/newflip/:produto",
      component: NewFlip,
      meta: {
        publico: true
      }
    },
    {
      path: "/newflip/:produto/:data/:edicao",
      component: NewFlip,
      meta: {
        publico: true
      }
    },
    {
      path: "/login",
      component: Login,
      meta: {
        publico: true,
        somenteDeslogado: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  const publico = to.matched.some((record) => record.meta.publico);
  const logout = to.matched.some((record) => record.meta.somenteDeslogado);
  const logado = localStorage.getItem("pwK") ? true : false;

  if (!publico && !logado) {
    var promo = to.fullPath.includes("?promo=1"); //para transferir o parâmetro promo ao login (se tentar acessar a url no plano e não estiver logado)
    return next({
      path: "/login" + (promo ? "?promo=1" : ""),
      query: to.fullPath != "/" ? { redirect: promo ? to.fullPath.replace("?promo=1", "") : to.fullPath } : ""
    });
  } else if (publico && logout && to.fullPath == "/login" && from.fullPath != "/login") {
    return next({
      path: "/login",
      query: to.fullPath != "/" ? { redirect: from.fullPath } : ""
    });
  }

  if (to.query.redirect_uri && logado) {
    //* Se redirecionamento solicitado e usuário já está logado, apenas redireciona
    window.location = to.query.redirect_uri + "?code=" + localStorage.getItem("pwK");
    return;
  }

  if (logado && logout) {
    return next("/");
  }

  next();
});

export default router;
